import { defineStore } from 'pinia';
export const useExplorerStore = defineStore('explorer', {
    state: () => ({
        searchQuery: '',
        activeTab: '',
        filters: {
            modality: [],
            domain: [],
            use_case: [],
            seller_badges: [],
            eval_total_tasks: '',
            eval_cost_per_run: '',
            eval_model_name: '',
            size: '',
            date_range: '',
            price_range: '',
            eval_average_difficulty: '',
            eval_score_range: '',
            eval_run_time_max: '',
            type: '',
        },
    }),

    actions: {
        initStore() {
            
            const savedState = localStorage.getItem('explorer-store');
            if (savedState) {
                this.$patch(JSON.parse(savedState));
            }


            this.$subscribe((mutation, state) => {
                localStorage.setItem('explorer-store', JSON.stringify(state));
            });
        },
        setSearchQuery(query) 
        {
            this.searchQuery = query;
        },
        setFilter(key, value) {
            this.filters[key] = value
        },
        setActiveTab(tab) {
            this.activeTab = tab;
        },
        forceTabChange(tab) {
            this.activeTab = tab;
            
            window.dispatchEvent(new CustomEvent('tab-changed', { 
                detail: { tab, source: 'store' } 
            }));
        },
        clearFilters() {
            this.searchQuery = '';
            this.filters = {
                modality: [],
                domain: [],
                use_case: [],
                seller_badges: [],
                eval_total_tasks: '',
                eval_cost_per_run: '',
                eval_model_name: '',
                size: '',
                date_range: '',
                price_range: '',
                eval_average_difficulty: '',
                eval_score_range: '',
                eval_run_time_max: '',
                type: '',
            }
        }
    }
  
})